export const getNotSummarizedText = (isTicketAgent: boolean) =>
  `You’re about to close the ${
    isTicketAgent ? 'Remediation ' : ''
  }Copilot chat, but the insights haven't been summarized nor saved to the Ticket Fixes tab. If you proceed, the chat will be closed and insights will be lost.`;

export const getNotSavedToFixesText = (isTicketAgent: boolean) =>
  `You’re about to close the ${
    isTicketAgent ? 'Remediation ' : ''
  }Copilot chat, but the insights haven't been saved to the Ticket Fixes tab. If you proceed, the chat will be closed and insights will be lost.`;

export const REDUCED_CONTEXT_MSG = 'This session was initiated with limited context due to the ticket containing a large volume of data.';

export const defaultSessionData = { chatRunInfo: { threadId: '' }, defaultPrompts: [], useFallbackQueries: false };
